import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { KeyRound, ArrowRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import api from '../lib/api'
import { useAuthStore } from '../store/authStore'

/**
 * Upozornění u AI funkcí, když přihlášený uživatel nemá uložený vlastní AI klíč.
 * Odkáže rovnou do nastavení na záložku AI klíče. Hostům (nepřihlášeným) se nezobrazuje.
 */
export default function AiKeyBanner() {
  const { t } = useTranslation()
  const { isAuthenticated } = useAuthStore()
  const { data: keys } = useQuery({
    queryKey: ['my-ai-keys'],
    queryFn: () => api.get('/ai/my-keys').then((r) => r.data.keys),
    enabled: isAuthenticated,
  })

  // Nezobrazovat při načítání (keys === undefined), hostům, ani když klíč existuje.
  if (!isAuthenticated || keys === undefined || (keys && keys.length > 0)) return null

  return (
    <div className="flex items-center gap-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800/40 rounded-xl p-3 mb-4">
      <KeyRound className="w-5 h-5 text-amber-500 shrink-0" />
      <p className="text-sm text-amber-800 dark:text-amber-200 flex-1">
        {t('aikey.banner', { defaultValue: 'Nemáte uložený vlastní AI klíč. Ulož si ho v nastavení a nebudeš ho muset zadávat u každého nástroje.' })}
      </p>
      <Link to="/profile?tab=ai_keys"
        className="inline-flex items-center gap-1 text-sm font-semibold text-amber-700 dark:text-amber-300 hover:underline shrink-0">
        {t('aikey.banner_cta', { defaultValue: 'Nastavit AI klíč' })} <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  )
}
